import { Link } from './link';
import { Repository } from './repository';

type CommitStatus = {
  // TODO this should be its own type
  commit?: {
    hash: string;
    type: string;
    links: {
      html: Link;
      self: Link;
    };
  };
  created_on: string;
  description: string;
  key: string;
  links: {
    commit: Link;
    self: Link;
  };
  name: string;
  refname?: string;
  repository?: Repository;
  state: 'SUCCESSFUL' | 'FAILED' | 'INPROGRESS' | 'STOPPED';
  updated_on: string;
  url: string;
};

type BBBuildStatus = CommitStatus & {
  type: 'build';
};

declare global {
  namespace BB {
    type BuildStatus = BBBuildStatus;
  }
}

export type BuildStatus = BBBuildStatus;
